import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class CreateAIMomentByIdUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (customer: string, lob: string, type: string, description: string, weight: number, options: string, sec_response: string, channel: string): Promise<any> => {
        return await this._aiRepository.CreateAIMoment(customer, lob, type, description, weight, options, sec_response, channel);
    }
}

export const CreateAIMomentByIdUseCaseName = "CreateAIMomentByIdUseCaseName";